export class AdditionalFee {
    FeeNumber: number;
    Fee: number | null;

    constructor(FeeNumber: number, Fee: number) {
        this.FeeNumber = FeeNumber;
        this.Fee = Fee;
    }
}
